export default __webpack_public_path__ + "static/media/SadFace.359e3616.png";